/**
 * Shared query-builder helpers for `akten` list/count queries.
 *
 * Soft-deleted akten (geloescht=true) stay in the DB so that cross-refs
 * like linked_akte_id and rentsoft_booking_id keep resolving — but they
 * must never surface in list views, dashboard counts, or navigation badges.
 */
export function excludeDeleted<T>(q: T): T {
  return (q as any).eq('geloescht', false);
}
